import { render } from "./cod-income-withdrawal.vue?vue&type=template&id=d6aeadb6&ts=true"
import script from "./cod-income-withdrawal.vue?vue&type=script&lang=ts"
export * from "./cod-income-withdrawal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__